<template>
  <div>
    <RigaIntervento v-for="(intervento, index) in this.listaInterventiShow" 
      :key="index"
      :index="index"
      :intervento="intervento">

    </RigaIntervento>
  </div>
</template>
<script>

import RigaIntervento from "@/components/RigaIntervento.vue";


export default {
  name: "GrigliaInterventiInCorso",  
  components: {
    RigaIntervento
  },
  data(){
    return {
      listaInterventiShow: []  
    }
  },
  watch:{
    listaInterventi: function(newValue){
      this.listaInterventiShow = newValue;
    }
  },
  props: {
    listaInterventi: Array
  },  
  mounted: function(){
      this.$store.dispatch({
        type: "getEsitiOperazioni",
        token: this.$store.getters.getUtente.Token,
      });
  }
}
</script>